/**
 * Haptic feedback via the Web Vibration API.
 * Supported on Android (Chrome, Firefox, Samsung Internet) and Android PWA.
 * Silently ignored on iOS (Safari blocks vibration — no error thrown).
 */

function canVibrate() {
  return typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
}

/**
 * Trigger a haptic pulse.
 * @param {number | number[]} pattern - duration in ms, or vibrate/pause pattern array
 */
export function vibrate(pattern = 5) {
  if (!canVibrate()) return;
  try {
    navigator.vibrate(pattern);
  } catch (_) {
    // ignore — some browsers throw if vibration is not permitted
  }
}

/** Preset patterns */
export const HAPTICS = {
  /** Subtle tap for regular button presses */
  TAP: 5,
  /** Slightly stronger for important actions (save, confirm) */
  MEDIUM: 12,
  /** Success pattern for level-up or challenge completion */
  SUCCESS: [14, 22, 24],
};
